import 'lazysizes';
import Alpine from "alpinejs";
import AsyncAlpine from "async-alpine";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";
import validate from "@colinaut/alpinejs-plugin-simple-validate";
import { setupFabrik } from "@core/js/fabrik.js";

Alpine.plugin(AsyncAlpine);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(validate);
setupFabrik(Alpine);

// Client-specific Alpine components go here

window.Alpine = Alpine;
Alpine.start();
